module.exports = __webpack_public_path__ + "static/media/Cabinet4_After.f8b055fc.jpg";